import React,{useState,useEffect} from 'react';
import Select from 'react-select';
import { JSON_ONE, JSON_TWO, JSON_THREE } from "./JSON_DATA";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
function AvailablePayModes() {
const [OptionData, SetOptionData] = useState([])
const [selectedOption, SetselectedOption] = useState([])
const [TabCheck, SetTabCheck] = useState(false)
useEffect(() => {
const options = [
{ value: '1', label: 'version Check Request' },
{ value: '2', label: 'load Money Request' },
{ value: '3', label: 'load Money List Request' },
{ value: '4', label: 'get Beneficiary List Request' },
{ value: '5', label: 'validate OTP Req' },
{ value: '6', label: 'transactions By Day Req' },
{ value: '7', label: 'transactions By Customer Id Req' },
{ value: '8', label: 'transactions By Transaction Id Req' },
];
SetOptionData(options)
SetselectedOption({ value: '1', label: 'version Check Request' })
}, [])
const onChangeSelected = (data) => {
SetselectedOption(data)
}
const onClickCangeTab = () => {
SetTabCheck(!TabCheck);
}
const funJSON_DATA = () => {
if (selectedOption.value == 1) {
return (
<pre>
                    {JSON.stringify(JSON_ONE, null, 2)}
                </pre>
)
} else if (selectedOption.value == 2) {
return (
<pre>
                    {JSON.stringify(JSON_TWO, null, 2)}
                </pre>
)
} else if (selectedOption.value == 3) {
return (
<pre>
                    {JSON.stringify(JSON_THREE, null, 2)}
                </pre>
)
} else {
return (
<div>
   No Data
</div>
)
}
}
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_content">
               <h1>Available Pay Modes</h1>
               <hr />
               <p class="mt-30">With SafexPay Payouts, you can choose from two available payment modes:</p>
               <p class="mt-30"><b>Bank Transfers:</b> Payouts can be made directly to the beneficiary's bank account using NEFT, RTGS, or IMPS modes. It is a secure, fast, and convenient mode for payouts.</p>
               <p class="mt-30"><b>UPI:</b> Payouts can be made using the Unified Payments Interface (UPI), which enables instant fund transfers. This is a popular pay mode for small value transactions.</p>
            </section>
         </div>
         <div class="col-md-4">
         </div>
      </div>
   </div>
</div>
)
}
export default AvailablePayModes